import { TemperatureAlertsDataInterface } from "../../../../../redux/interfaces/raports.interface";
import { useAppDispatch } from "../../../../../redux/hooks";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import {
  openSolvingTemperatureAlertModal,
  setSelectedTemperatureAlert,
} from "../../../../../redux/reducer/raports.reducer";

function TemperatureAlertsActionButtons({
  crudData,
}: {
  itemId: string;
  crudData: TemperatureAlertsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const canResolve = crudData.status === 0;

  const handleChangePickingDate = () => {
    if (!canResolve) return;
    dispatch(setSelectedTemperatureAlert(crudData));
    dispatch(openSolvingTemperatureAlertModal());
  };

  return (
    <ActionMenu
      title={crudData.plate}
      items={[
        {
          id: "resolve-temperature-alert",
          label: "Rezolva alerta",
          icon: "SOLVE_ALERT",
          tooltip: canResolve
            ? "Deschide formularul pentru rezolvarea alertei de temperatura."
            : "Alerta a fost deja rezolvata si nu mai poate fi modificata.",
          disabled: !canResolve,
          onClick: handleChangePickingDate,
        },
      ]}
    />
  );
}

export default TemperatureAlertsActionButtons;
